import React from "react";

// Stella a 5 punte (punta verso l'alto) centrata in (cx,cy) con raggio r
function starPoints(cx, cy, r) {
  const pts = [];
  for (let i = 0; i < 5; i++) {
    const oa = -Math.PI / 2 + (i * 2 * Math.PI) / 5;
    const ia = oa + Math.PI / 5;
    pts.push([cx + r * Math.cos(oa), cy + r * Math.sin(oa)]);
    pts.push([cx + r * 0.4 * Math.cos(ia), cy + r * 0.4 * Math.sin(ia)]);
  }
  return pts.map((p) => p.map((n) => n.toFixed(2)).join(",")).join(" ");
}

// Icona Unione Europea: cerchio di 12 stelle (monocromatica, usa currentColor)
export default function EuIcon({ size = 16, className, style, title = "Unione Europea" }) {
  const cx = 12, cy = 12, ring = 8.2, starR = 1.55;
  const stars = [];
  for (let i = 0; i < 12; i++) {
    const a = -Math.PI / 2 + (i * 2 * Math.PI) / 12;
    stars.push(<polygon key={i} points={starPoints(cx + ring * Math.cos(a), cy + ring * Math.sin(a), starR)} />);
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} style={style} role="img" aria-label={title}>
      {stars}
    </svg>
  );
}
